import { Store } from 'redux'

import { getSessionTimeout } from '../redux/config/selectors'
import { UserActions } from '../redux/user/actions'
import { isUserLoggedIn } from '../redux/user/selectors'

export class AutoLogout {
  store?: Store
  timeout?: number

  public setStore(store: Store) {
    this.store = store
  }

  public scheduleAutoLogout() {
    const { store } = this

    if (!store) return
    if (this.timeout) window.clearTimeout(this.timeout)

    const timeoutTime = getSessionTimeout(store.getState())

    if (timeoutTime) {
      this.timeout = window.setTimeout(() => {
        if (!isUserLoggedIn(store.getState())) return
        store.dispatch(UserActions.detectSessionTimeout())
      }, timeoutTime)
    }
  }
}

export const autoLogout = new AutoLogout()
